class EdgePanel {
  constructor() {
    this.root = document.querySelector(":root");
    this.defaultEdgePanelWidth = this.getCssVariable(
      "--rx-layout-edge-panel-width"
    );
  }

  // Getting a CSS variable value
  getCssVariable(variable) {
    let rootStyle = getComputedStyle(this.root);
    return rootStyle.getPropertyValue(variable);
  }

  showEdgePanel() {
    document
      .querySelector(".layout-edge-panel")
      .classList.remove("js-disable-observe-width");

    this.root.style.setProperty(
      "--rx-layout-edge-panel-width",
      this.defaultEdgePanelWidth
    );

    document.body.classList.remove("layout-edge-panel--hover");
  }

  hoverEdgePanel() {
    document
      .querySelector(".layout-edge-panel")
      .classList.add("js-disable-observe-width");

    this.root.style.setProperty("--rx-layout-edge-panel-width", "0px");

    document.body.classList.add("layout-edge-panel--hover");
  }

  toggleEdgePanel() {
    document.body.classList.contains("layout-edge-panel--hover")
      ? this.showEdgePanel()
      : this.hoverEdgePanel();
  }

  attachEventListener() {
    const _this = this;
    let edgePanelTrigger = document.querySelector(".edge-panel-trigger");

    if (!edgePanelTrigger) {
      console.log(
        "%cEdge panel trigger or edge panel not found",
        "background:red; color:#fff"
      );

      return false;
    }

    edgePanelTrigger.addEventListener("click", function () {
      _this.toggleEdgePanel();
    });
  }

  init() {
    this.attachEventListener();
  }
}

const edgePanel = new EdgePanel();
edgePanel.init();
